import * as React from 'react';

interface BodyProps {
  children?: React.ReactNode[] | React.ReactNode;
}

const Body = ({ children }: BodyProps) => {
  return <div className="modal-body pd-25">{children}</div>;
};

export default Body;
